import { render, staticRenderFns } from "./SystemSettingSystemEditor.vue?vue&type=template&id=4a840d68&scoped=true&"
import script from "./SystemSettingSystemEditor.vue?vue&type=script&lang=ts&"
export * from "./SystemSettingSystemEditor.vue?vue&type=script&lang=ts&"
import style0 from "./SystemSettingSystemEditor.vue?vue&type=style&index=0&id=4a840d68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a840d68",
  null
  
)

export default component.exports